import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-promo-overlay.component.scss';
var BannerPromoOverlay = /** @class */ (function (_super) {
    tslib_1.__extends(BannerPromoOverlay, _super);
    function BannerPromoOverlay(element) {
        return _super.call(this, element) || this;
    }
    BannerPromoOverlay.prototype.init = function () {
        this.closeButton = this.element.querySelector('.js-banner-close');
        this.closeButtonDesktop = this.element.querySelector('.banner-promo-overlay__close--button');
        this.container = this.element;
    };
    BannerPromoOverlay.prototype.bindEvents = function () {
        var _this = this;
        this.closeButton.addEventListener('click', function (event) { return _this.closeBanner(); });
        this.closeButtonDesktop.addEventListener('click', function (event) { return _this.closeBanner(); });
    };
    BannerPromoOverlay.prototype.closeBanner = function () {
        this.container.classList.add('d-none');
    };
    return BannerPromoOverlay;
}(Base));
export { BannerPromoOverlay };



//////////////////
// WEBPACK FOOTER
// ./components/banner-promo-overlay/banner-promo-overlay.component.ts
// module id = 579
// module chunks = 0